import { useLocation, useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import articleData from "../../data/financeFacts.json";
import FactsSection from "../../components/FactsSection";
import AdComponent from "../../components/AdComponent";
const BonusResult = () => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user.user);
    const location = useLocation();
    const navigate = useNavigate();
    const results = location.state;
    const article = articleData?.PAGE4 || {};
    useEffect(() => {
        if (!results) {
            navigate('/');
        } else {
            if(user.first_visit === 1) {
                const updateUser = {
                    coins: 200,
                    first_visit: 0
                };
        
                dispatch({ type: "UPDATE_USER", payload: updateUser });
            }
        }
        
    }, [results, navigate, dispatch, user?.first_visit]);

    return (
        <>
            <AdComponent />
            <section className="play-quiz-section pt">
                <div className="container">
                    <div className="play-quiz-card play-now-card m-0">
                        <div className="play-quiz-icon">
                            <img src="/assets/images/coin-unscreen.gif" alt="Loans and Cards" />
                        </div>
                        <h2 className="play-quiz-title"> You have got {results?.coins_earned ?? 200} coins</h2>
                        <p className="play-quiz-desc">Check out more quizzes to test your skills and keeps grabbing more coins!</p> 
                        <Link to={"/"} className="btn-join signin-btn btn">Play Now</Link>
                    </div>  
                </div>
            </section>

            <section className="common-box-section pt pb">
                <div className="container">
                    <div className="common-box quiz-box">
                        <h2 className="common-title">Participate in quizzes and earn coins!</h2> 
                        <ul className="common-content">
                            <li>The completion of each quiz fetches you coins.</li>
                            <li>Join millions of quiz fans who rely on us.</li>
                            <li>Improve your knowledge with our free, quality quizzes.</li>
                            <li>Compete against a wide variety of players from across the world.</li> 
                            <li>Discover popular categories like Term Life Insurance, Stock Exchange, Insurance, and Loans &amp; Cards!</li>
                        </ul> 
                    </div>
                </div>
            </section>
            <section className="facts-section">
                <div className="container">
                    <div className="finance-fact">
                        <h2 className="fw-bold mb-4">{article?.title}</h2>
                    </div>
                    {
                        article?.content?.map((item, index) => (
                            <FactsSection key={index} item={item} />
                        ))
                    }
                    <div className="article-card">
                        <h2 className="article-card-title">{article?.action?.title}</h2>
                        
                        <p className="article-card-desc">
                            <strong className="desc-color">{article?.action?.title1}</strong> {article?.action?.desc1}
                        </p>
                        
                        <p className="article-card-desc">
                            <strong className="desc-color">{article?.action?.title2}</strong> {article?.action?.desc2}
                        </p>
                        
                        <p className="article-card-desc">
                            {
                                article?.action?.list.map((list, index) => (
                                    <>{list}<br /></>
                                ))
                            }
                        </p>
                    </div>
                </div>
            </section>
        </>
    )
}

export default BonusResult;